import { render, staticRenderFns } from "./UserScientificDegreeCards.vue?vue&type=template&id=52d8d12b&"
import script from "./UserScientificDegreeCards.vue?vue&type=script&lang=js&"
export * from "./UserScientificDegreeCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports